import Table from "../../../../components/Table.jsx";
import Pagination from "../../../../components/Pagination.jsx";
import Filters from "./Filters.jsx";
import DetailsTableWithControls from "./DetailsTableWithControls.jsx";
import styles from "../css/reverseStock.module.css";

export default function ViewRenderer({
  roleId,
  activeSegment,
  mode,
  // filters
  fromDate,
  setFromDate,
  toDate,
  setToDate,
  // pagination
  currentPage,
  setCurrentPage,
  totalPages,
  pageData,
  // actions
  selectAll,
  toggleSelectAll,
  handleReturnToStock,
  // column sets
  columns,
  historyColumns,
  detailColumns,
  frontShopDetailColumns,
  otcDetailColumnsPending,
  historyDetailColumns,
  frontShopHistoryDetailColumns,
  otcHistoryDetailColumns,
}) {
  if (roleId !== 6 && activeSegment === "Front Shop" && (mode === "list" || mode === "history")) {
    return (
      <>
        {mode === "history" && (
          <Filters
            fromDate={fromDate}
            setFromDate={setFromDate}
            toDate={toDate}
            setToDate={setToDate}
          />
        )}
        <Table columns={mode === "history" ? historyColumns : columns} data={pageData} />
        <div className={styles.paginationContainer}>
          <Pagination currentPage={currentPage} totalPages={totalPages} onPageChange={setCurrentPage} />
        </div>
      </>
    );
  }

  if (roleId !== 6 && activeSegment === "OTC" && (mode === "list" || mode === "history")) {
    return (
      <>
        {mode === "history" && (
          <Filters
            fromDate={fromDate}
            setFromDate={setFromDate}
            toDate={toDate}
            setToDate={setToDate}
          />
        )}
        <Table columns={mode === "history" ? historyColumns : columns} data={pageData} />
        <div className={styles.paginationContainer}>
          <Pagination currentPage={currentPage} totalPages={totalPages} onPageChange={setCurrentPage} />
        </div>
      </>
    );
  }

  if (mode === "list") {
    return (
      <>
        <Table columns={columns} data={pageData} />
        <div className={styles.paginationContainer}>
          <Pagination currentPage={currentPage} totalPages={totalPages} onPageChange={setCurrentPage} />
        </div>
      </>
    );
  }

  if (mode === "details") {
    return (
      <>
        <DetailsTableWithControls
          columns={activeSegment === "Front Shop" ? frontShopDetailColumns : activeSegment === "OTC" ? otcDetailColumnsPending : detailColumns}
          data={pageData}
          selectAll={selectAll}
          onToggleSelectAll={toggleSelectAll}
          onReturn={handleReturnToStock}
        />
        <div className={styles.paginationContainer}>
          <Pagination currentPage={currentPage} totalPages={totalPages} onPageChange={setCurrentPage} />
        </div>
      </>
    );
  }

  if (mode === "historyDetails") {
    return (
      <>
        {activeSegment === "Front Shop" ? (
          <Table columns={frontShopHistoryDetailColumns} data={pageData} />
        ) : activeSegment === "OTC" ? (
          <Table columns={otcHistoryDetailColumns} data={pageData} />
        ) : (
          <Table columns={historyDetailColumns} data={pageData} />
        )}
        <div className={styles.paginationContainer}>
          <Pagination currentPage={currentPage} totalPages={totalPages} onPageChange={setCurrentPage} />
        </div>
      </>
    );
  }

  // default: history list
  return (
    <>
      <Filters
        fromDate={fromDate}
        setFromDate={setFromDate}
        toDate={toDate}
        setToDate={setToDate}
      />
      <Table columns={historyColumns} data={pageData} />
      <div className={styles.paginationContainer}>
        <Pagination currentPage={currentPage} totalPages={totalPages} onPageChange={setCurrentPage} />
      </div>
    </>
  );
}
